// Page d'état. Les composants marqués `probe` sont réellement interrogés ;
// les autres sont affichés comme non supervisés plutôt que « opérationnels ».

export const COMPONENTS = [
  { key: "web", name: "Application web", desc: "performcustom.com", probe: "frontend" },
  { key: "api", name: "API", desc: "api.performcustom.com", probe: "api" },
  { key: "auth", name: "Authentification", desc: "Liens de connexion et sessions", probe: "api" },
  { key: "db", name: "Base de données", desc: "Comptes, profils et sessions", probe: "db" },
  { key: "email", name: "Envoi d'e-mails", desc: "Acheminement des liens de connexion", probe: null,
    note: "Dépend de Resend. Nous n'avons pas encore de sonde automatique sur ce composant." },
];

export const LABELS = {
  operational: "Opérationnel",
  degraded: "Performances dégradées",
  partial: "Panne partielle",
  major: "Panne majeure",
  maintenance: "Maintenance",
  unmonitored: "Non supervisé",
  checking: "Vérification…",
};

// Historique réel. Il commence à la mise en ligne : nous n'inventons pas d'incidents passés.
export const INCIDENTS = [];
export const MAINTENANCE = [];
export const HISTORY_SINCE = "16 septembre 2026";

export const SUBSCRIBE = {
  intro: "Soyez prévenu en cas d'incident.",
  channels: [
    { key: "email", label: "Par e-mail", desc: "Un message à l'ouverture et à la clôture de chaque incident.", available: false },
    { key: "rss", label: "Flux RSS", desc: "À brancher dans votre lecteur ou votre canal d'équipe.", available: false },
    { key: "webhook", label: "Webhook", desc: "Une requête HTTP vers l'URL de votre choix.", available: false },
  ],
  note: "Ces canaux ne sont pas encore ouverts. En attendant, cette page reflète l'état réel en direct : elle interroge nos services à chaque chargement.",
};
